import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import { MentionList } from './mention-list';

export const suggestion = (
  mentions: Array<{ id: string; label: string; email?: string }>,
  onMentionSelect?: (mention: { id: string; label: string }) => void
) => ({
  items: ({ query }: { query: string }) => {
    return mentions
      .filter(item =>
        item.label.toLowerCase().startsWith(query.toLowerCase()) ||
        (item.email && item.email.toLowerCase().startsWith(query.toLowerCase()))
      )
      .slice(0, 10);
  },

  render: () => {
    let component: ReactRenderer;
    let popup: any;

    return {
      onStart: (props: any) => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        });
      },

      onUpdate(props: any) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props: any) {
        if (props.event.key === 'Escape') {
          popup[0].hide();
          return true;
        }

        return (component.ref as { onKeyDown?: (props: any) => boolean })?.onKeyDown?.(props);
      },

      onExit() {
        popup[0].destroy();
        component.destroy();
      },
    };
  },
});
